<template>
  <div>
    <carousel v-if="((is_responsive != true && !isMobile) || is_responsive == true)"
              :autoplay="false"
              :loop="false"
              :items="items"
              :autoplayHoverPause="true"
              :margin="24"
              :responsive="is_responsive == true?reponsive:false"
              :navText="navText"
    >
    <slot name="slides"></slot>
    </carousel>    
    <div v-if="(is_responsive != true && isMobile)">
      <slot name="slides"></slot>
    </div>
  </div>
</template>

<script>
import Carousel from 'vue-owl-carousel'
import Offer from './cards/offer'
import OfferEmpty from './cards/offer-empty'
import News from './cards/news'
import PressRelease from './cards/press-release'

export default {
  name: 'card-carousel',
  components: {
    News,
    Carousel,
    Offer,
    OfferEmpty,
    PressRelease,
  },
  props: {
    'module': String,
    'items': {
            type: Number,
            default: 4
    },
    'is_responsive': true,
  },
  computed: {
      isMobile() {
        return window.innerWidth < 992;
      }
    },  
  data() {
    return {
      reponsive: {
        "0": {
          items: 1,
          nav: false,
        },
        "576": {
          items: 2,
          nav: false,
        },
        "992": {
          items: 4,
          nav: true,
        }
      },
      navText: [
        '<i class="bi bi-chevron-compact-left"></i>',
        '<i class="bi bi-chevron-compact-right"></i>'
      ]
    }
  }
}
</script>